import { datadogRum } from '@datadog/browser-rum';
import parse from 'html-react-parser';

const parseWithCatch = (html, context) => {
  try {
    return parse(html);
  } catch (error) {
    const enrichedError = new Error(`HTML Parsing Error - ${error.message}`);
    Object.defineProperty(enrichedError, 'stack', {
      value: error.stack,
      enumerable: true,
    });
    datadogRum.addError(enrichedError, {
      html,
      context,
    });

    // continue to throw the error so it can be caught by the caller
    throw error;
  }
};

export default parseWithCatch;
